<template>
  <div>
    สิทธิ์การเข้าใช้งาน
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
